/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaTiposDivisionesVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaTiposDivisiones: React.FunctionComponent<ITablaTiposDivisionesVistaProps & InjectedIntlProps> = ({
    tiposDivisioness,
    cargarTiposDivisiones,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={tiposDivisioness}
            actions={acciones(manejarFormulario, cargarTiposDivisiones, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaTiposDivisiones);
